import WCCAttachment, { JSONWCCAttachment } from './attachment';

export default class WCCVimeoVideo extends WCCAttachment<JSONWCCAttachment> {
    cFullLink = ko.pureComputed(() => 'https://player.vimeo.com/video/' + this.link()); // 393655220
}